/**
 * /demo/indo-ghibli-wedding, /demo/pichwai-heritage-wedding, /demo/storybook-3d-wedding
 * Public showcases of the artistic scroll-experience wedding templates
 * (ported from feature/artistic-wedding-templates). Sample data only; no auth, no backend.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { TemplateRenderer } from '@/src/modules/templates/TemplateRenderer';
import '@/src/modules/templates';
import type { InvitationData } from '@/src/modules/templates/types';

const SAMPLE_DATE = '2027-02-14T18:30:00+05:30';

function demoData(templateId: string): InvitationData {
  return {
    id: `demo-${templateId}`,
    templateId,
    occasionType: 'WEDDING',
    status: 'PUBLISHED',
    eventName: 'Aarav & Mira',
    eventDate: SAMPLE_DATE,
    eventTime: '6:30 PM',
    eventVenue: 'Amrit Mahal Courtyard, Udaipur, Rajasthan',
    hostName: 'The Sharma & Mehta Families',
    customMessage: 'With the blessings of our families, we invite you to celebrate our wedding.',
    rsvpLink: 'https://invitecloud.in',
    customData: {
      wedding: {
        groom: { fullName: 'Aarav Sharma' },
        bride: { fullName: 'Mira Mehta' },
        weddingEvents: [
          { title: 'Mehndi', date: '2027-02-13T16:00:00+05:30', startTime: '4:00 PM', venue: 'Garden Lawn', visible: true },
          { title: 'Wedding Ceremony', date: SAMPLE_DATE, startTime: '6:30 PM', venue: 'Amrit Mahal Courtyard', visible: true },
        ],
      },
    },
    isPremium: true,
  } as InvitationData;
}

function ArtisticDemo({ templateId }: { templateId: string }) {
  return (
    <div className="relative min-h-screen bg-black">
      <Link
        to="/designs"
        className="fixed left-4 top-4 z-50 rounded-full border border-white/25 bg-black/35 px-4 py-2 text-xs tracking-wide text-white/85 backdrop-blur transition-colors hover:bg-black/55"
      >
        ← Back to designs
      </Link>
      <TemplateRenderer templateId={templateId} data={demoData(templateId)} />
    </div>
  );
}

export const IndoGhibliWeddingDemo = () => <ArtisticDemo templateId="exp-wedding-indo-ghibli-v1" />;
export const PichwaiHeritageWeddingDemo = () => <ArtisticDemo templateId="exp-wedding-pichwai-v1" />;
export const Storybook3dWeddingDemo = () => <ArtisticDemo templateId="exp-wedding-storybook-3d-v1" />;
